let clientId = 'c2b-admin-api'

if (process.env.NODE_ENV === 'development') {
  clientId = 'c2b-admin-api-dev'
}

export const initOptions = {
  realm: 'c2b', 
  url: 'https://accounts.c2bsoftware.com.br/auth', 
  clientId,
}
